import { NgModule } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import localeEn from "@angular/common/locales/en";
import localeNl from "@angular/common/locales/nl";
import localeFi from "@angular/common/locales/fi";
import localeSv from "@angular/common/locales/sv";
import localeZu from "@angular/common/locales/zu";
import { TranslateModule, TranslateCompiler } from "@ngx-translate/core";

import { LgConsoleConfiguration } from "@logex/framework/core";
import {
    LgLocalizationModule,
    ReferenceTranslateCompiler,
    useMessageFormatLocales,
    LG_LOCALIZATION_SETTINGS
} from "@logex/framework/lg-localization";
import { UiCoreModule } from "@logex/framework/ui-core";
import {
    IAppSession,
    LgUserflowConfiguration,
    LgUserflowService,
    LG_APP_CONFIGURATION,
    LG_APP_SESSION,
    LG_USERFLOW_CONFIGURATION,
    LG_USERFLOW_SERVICE,
    LG_USER_INFO
} from "@logex/framework/lg-application";
import {
    LgLayoutModule,
    LgLocalStorageFwUiStateService,
    LG_FW_UI_STATE_SERVICE
} from "@logex/framework/lg-layout";

import { SharedLocalizationSettingsService } from "./shared-localization-settings.service";
import { SharedConfigService } from "./shared-config.service";
import { SharedAppUser } from "./shared-app-user";
import { LgFiltersetModule } from "@logex/framework/lg-filterset";

const dummySession: IAppSession = {
    clientId: 10003,
    client: {
        id: 123,
        code: "123",
        name: "Test"
    },
    scenarioId: 1
};

registerLocaleData(localeEn);
registerLocaleData(localeNl);
registerLocaleData(localeFi);
registerLocaleData(localeSv);
registerLocaleData(localeZu);

@NgModule({
    imports: [
        UiCoreModule,
        LgLayoutModule,
        TranslateModule.forRoot({
            compiler: {
                provide: TranslateCompiler,
                useClass: ReferenceTranslateCompiler
            }
        }),
        LgFiltersetModule.forRoot(),
        LgLocalizationModule.forRoot({
            localizationUrlPrefix: "localization"
        })
    ],
    providers: [
        {
            provide: LgConsoleConfiguration,
            useValue: new LgConsoleConfiguration()
        },
        useMessageFormatLocales(["nl", "nl-NL", "en", "en-GB", "zu", "zu-ZA"]),
        {
            provide: LG_APP_CONFIGURATION,
            useFactory: (configService: SharedConfigService) => configService.getAppConfiguration(),
            deps: [SharedConfigService]
        },
        {
            provide: LG_LOCALIZATION_SETTINGS,
            useClass: SharedLocalizationSettingsService
        },
        {
            provide: LG_APP_SESSION,
            useValue: dummySession
        },
        {
            provide: LG_FW_UI_STATE_SERVICE,
            useClass: LgLocalStorageFwUiStateService
        },
        {
            provide: LG_USER_INFO,
            useValue: new SharedAppUser()
        },
        {
            provide: LG_USERFLOW_SERVICE,
            useExisting: LgUserflowService
        },
        {
            provide: LG_USERFLOW_CONFIGURATION,
            useClass: LgUserflowConfiguration
        }
    ]
})
export class SharedUtilLogexFrameworkRootModule {}
